import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const PageLoader = ({ message = 'Cargando...' }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.paper',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        {/* Logo/Brand */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              background: 'linear-gradient(45deg, #3b82f6, #1e40af)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 1,
            }}
          >
            CardQr
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Tarjetas de presentación digitales
          </Typography>
        </Box>

        {/* Loading spinner */}
        <Box sx={{ mb: 3 }}>
          <CircularProgress size={60} thickness={4} />
        </Box>

        {/* Loading message */}
        <Typography variant="h6" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default PageLoader; 